/**
 * JSON-Schema: string
 */
import { InvalidTypeFields, ISchemaTypeFoundation, IsNever, SchemaTypeName } from './core';

export interface ISchemaString<TSType extends string = string>
    extends ISchemaTypeFoundation<TSType> {
    type: SchemaTypeName.string;
    minLength?: number;
    maxLength?: number;
    pattern?: RegExp;
    format?: Exclude<SchemaStringFormat, SchemaStringFormat.date_time>;
}

export enum SchemaStringFormat {
    'date_time' = 'date-time',
    // 'date' = 'date', // prefer date-time
    // 'time' = 'time', // prefer date-time
    'email' = 'email',
    'hostname' = 'hostname',
    'ipv4' = 'ipv4',
    'ipv6' = 'ipv6',
    'json_pointer' = 'json-pointer',
    'regex' = 'regex',
    'uri_reference' = 'uri-reference',
    'uri' = 'uri',
    'uuid' = 'uuid',

    //  Custom, non-compliant formats: Need to convert! Use Type.string();
    'uri_http' = 'uri_http',
}

// If there is an error here, type uses an invalid field name
//  - NB: DO NOT DELETE
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type ValidateISchemaStringFields = IsNever<InvalidTypeFields<ISchemaString>>;
